/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Rule_Operator_NeqInputs */



/**
* | output |
* | --- |
* | "different from" |
*
* @param {Alarms_Form_Rule_Operator_NeqInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_form_rule_operator_neq = /** @type {((inputs?: Alarms_Form_Rule_Operator_NeqInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Rule_Operator_NeqInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("different from")
	return /** @type {LocalizedString} */ ("différente de")
});